import { useEffect, useState } from "react";

const PREFIX = "codvero.draft.";

/**
 * A message box's text kept on this device until it is sent: closing or reloading the page no longer loses what was
 * typed. Per-viewer convenience only (localStorage can be unavailable; then it is plain state).
 */
export function useDraft(key: string | null): [string, (v: string | ((prev: string) => string)) => void, () => void] {
  const read = () => {
    if (!key) return "";
    try { return localStorage.getItem(PREFIX + key) ?? ""; } catch { return ""; }
  };
  const [text, setText] = useState(read);
  useEffect(() => setText(read()), [key]);
  useEffect(() => {
    if (!key) return;
    try {
      if (text) localStorage.setItem(PREFIX + key, text);
      else localStorage.removeItem(PREFIX + key);
    } catch { /* private mode */ }
  }, [key, text]);
  return [text, setText, () => setText("")];
}
